import { useState, useEffect, useMemo } from "react";
import { newsService } from "../dependencyInjection";
import { News } from "../services/NewsService";
import { unsubscribe } from "../../../../utils";

type UseAddNews = (caption: string, description: string, date: string) => Promise<void>;
type UseChangeNews = (newsData: News) => Promise<void>;
type UseDeleteNews = (id: number) => Promise<void>;
type UseUserResult = [News[], boolean, UseAddNews, UseChangeNews, UseDeleteNews];

export function useNews(): UseUserResult {
  const [news, setNews] = useState<News[]>([]);
  const [pendind, setPending] = useState(false);
  useEffect(() => {
    const subNews = newsService.news$.subscribe((userInfo) => {
      setNews(userInfo);
    });
    const subLoading = newsService.loading$.subscribe((loading) => {
      setPending(loading);
    });
    return unsubscribe(subNews, subLoading);
  }, []);

  const getNews = useMemo(
    () => async () => {
      try {
        await newsService.getNews();
      } catch (e) {}
    },
    [],
  );

  useEffect(() => {
    getNews();
  }, [getNews]);

  const addNews = useMemo(
    () => async (caption: string, description: string, date: string) => {
      try {
        await newsService.addNews(caption, description, date);
      } catch (e) {}
    },
    [],
  );

  const changeNews = useMemo(
    () => async (newsData: News) => {
      try {
        await newsService.changeNews(newsData);
      } catch (e) {}
    },
    [],
  );

  const deleteNews = useMemo(
    () => async (id: number) => {
      try {
        await newsService.deleteNews(id);
      } catch (e) {}
    },
    [],
  );

  return [news, pendind, addNews, changeNews, deleteNews];
}
